import { render, staticRenderFns } from "./headerBody.vue?vue&type=template&id=7f15d811&"
import script from "./headerBody.vue?vue&type=script&lang=js&"
export * from "./headerBody.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports